import { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import GetUserData from './GetUserData';

export function useUserPermissions() {
  const { hubId } = useParams(); // ← obtiene el hubId desde la URL
  const [permisos, setPermisos] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermisos = async () => {
      const user = auth.currentUser;
      if (!user || !hubId) {
        setPermisos({});
        setLoading(false);
        return;
      }

      const userDocRef = doc(db, "usuarios", user.uid);
      const userSnap = await getDoc(userDocRef);

      if (!userSnap.exists()) {
        setPermisos({});
        setLoading(false);
        return;
      }

      const userData = userSnap.data();

      // Si es superadmin, tiene acceso total
      if (userData.hubId?.includes("__superadmin__")) {
        setPermisos({
          verCalendario: 'lectura_escritura',
          verCompras: 'lectura_escritura',
          verDocs: 'lectura_escritura',
          verPlanes: 'lectura_escritura',
          verGestion: 'lectura_escritura',
          verAccPlan: 'lectura_escritura',
          verDashboard: 'lectura_escritura',
          accesoTotal: true,
        });
      } else {
        // Si no, cargamos los permisos específicos para el hub actual
        const permisosPorHub = userData.permisos?.[hubId] || {};
        setPermisos(permisosPorHub);
      }

      setLoading(false);
    };

    fetchPermisos();
  }, [hubId]);

  return { permisos, loading };
}

export function useUserRole() {
  const { userData } = GetUserData();

  const isAdmin = useMemo(() => {
    return userData?.rol === 'admin' || userData?.hubId?.includes('__superadmin__');
  }, [userData]);

  const hasRole = (roles = []) => {
    return roles.includes(userData?.rol);
  };

  return {
    userData,
    isAdmin,
    hasRole,
  };
}
